import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\ContactDirectory\ArchiveDirectoryRecordsController::__invoke
* @see app/Http/Controllers/ContactDirectory/ArchiveDirectoryRecordsController.php
* @route '/api/contact-directory/archive'
*/
const ArchiveDirectoryRecordsController = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: ArchiveDirectoryRecordsController.url(options),
    method: 'post',
})

ArchiveDirectoryRecordsController.definition = {
    methods: ["post"],
    url: '/api/contact-directory/archive',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\ContactDirectory\ArchiveDirectoryRecordsController::__invoke
* @see app/Http/Controllers/ContactDirectory/ArchiveDirectoryRecordsController.php
* @route '/api/contact-directory/archive'
*/
ArchiveDirectoryRecordsController.url = (options?: RouteQueryOptions) => {
    return ArchiveDirectoryRecordsController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\ContactDirectory\ArchiveDirectoryRecordsController::__invoke
* @see app/Http/Controllers/ContactDirectory/ArchiveDirectoryRecordsController.php
* @route '/api/contact-directory/archive'
*/
ArchiveDirectoryRecordsController.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: ArchiveDirectoryRecordsController.url(options),
    method: 'post',
})

export default ArchiveDirectoryRecordsController